// // Bottom scroll-to-offer CTA
// // Staging working example
// (function () {
//   const cta = document.querySelector('[data-sticky-scroll-cta]');
//   if (!cta) return;

//   const btn = cta.querySelector('[data-scroll-to-offer]');
//   if (!btn) return;

//   const getTargetEl = () => {
//     const selector = btn.getAttribute('data-offer-target') || '';
//     if (!selector) return null;
//     try {
//       return document.querySelector(selector);
//     } catch (e) {
//       return null;
//     }
//   };

//   const getOffset = () => {
//     const n = Number(btn.getAttribute('data-scroll-offset') || 0);
//     return Number.isFinite(n) ? n : 0;
//   };

//   const scrollToTarget = () => {
//     const target = getTargetEl();
//     if (!target) return;

//     const offset = getOffset();
//     const top = window.pageYOffset + target.getBoundingClientRect().top - offset;

//     window.scrollTo({ top, behavior: 'smooth' });
//   };

//   btn.addEventListener('click', scrollToTarget);
// })();

// Bottom scroll-to-offer CTA
// Keeps click-to-scroll behavior + hides CTA when target covers >= 30% of viewport
(function () {
  const cta = document.querySelector('[data-sticky-scroll-cta]');
  if (!cta) return;

  const btn = cta.querySelector('[data-scroll-to-offer]');
  if (!btn) return;

  const lpLink = document.querySelector('.sticky-scroll-cta__btn[data-acq-lp-link]');
  // Optional: the acquisition LP menu. Absent on pages without it (then this has no effect).
  const lpMenu = document.querySelector('#acq-lp-menu');

  const getTargetEl = () => {
    const selector = btn.getAttribute('data-offer-target') || '';
    if (!selector) return null;
    try {
      return document.querySelector(selector);
    } catch (e) {
      return null;
    }
  };

  const getOffset = () => {
    const n = Number(btn.getAttribute('data-scroll-offset') || 0);
    return Number.isFinite(n) ? n : 0;
  };

  const scrollToTarget = () => {
    const target = getTargetEl();
    if (!target) return;

    const offset = getOffset();
    const top = window.pageYOffset + target.getBoundingClientRect().top - offset;

    window.scrollTo({ top, behavior: 'smooth' });
  };

  // Keep your original working click behavior
  btn.addEventListener('click', scrollToTarget);

  /* -----------------------------------------
     Visibility behavior (viewport coverage)
     Hide when target covers >= 30% of viewport
     Show when target covers < 30% of viewport
  ------------------------------------------ */

  let lastHidden = null;
  const setHidden = (hidden) => {
    hidden = !!hidden;
    cta.setAttribute('aria-hidden', hidden ? 'true' : 'false');
    // Hide menu link
    if (lpLink) lpLink.setAttribute('aria-hidden', hidden ? 'true' : 'false');

    // WCAG 2.2 (2.4.11 Focus Not Obscured): while the fixed bar is visible, reserve
    // space at the bottom so a keyboard-focused element can't be scrolled behind it.
    // Only touch layout when the state actually changes (avoids reflow on every scroll).
    if (hidden !== lastHidden) {
      lastHidden = hidden;
      document.documentElement.style.scrollPaddingBottom = hidden ? '' : cta.offsetHeight + 'px';
    }
  };

  const getViewportCoverageRatio = () => {
    const target = getTargetEl();
    if (!target) return 0;

    const r = target.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    const visibleTop = Math.max(r.top, 0);
    const visibleBottom = Math.min(r.bottom, vh);
    const visiblePx = Math.max(0, visibleBottom - visibleTop);

    return visiblePx / Math.max(1, vh);
  };

  // Hide the bar whenever any part of the LP menu is within the viewport.
  const isLpMenuInViewport = () => {
    if (!lpMenu) return false;
    const r = lpMenu.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    return r.bottom > 0 && r.top < vh;
  };

  const updateVisibility = () => {
    const ratio = getViewportCoverageRatio();
    setHidden(ratio >= 0.3 || isLpMenuInViewport());
  };

  // Use IntersectionObserver only as a cheap "something changed" trigger
  const target = getTargetEl();
  if ('IntersectionObserver' in window && (target || lpMenu)) {
    const io = new IntersectionObserver(updateVisibility, {
      root: null,
      threshold: [0, 0.01, 1],
    });
    if (target) io.observe(target);
    if (lpMenu) io.observe(lpMenu);
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility);
  updateVisibility();
})();
